import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IFiscalRegistry} from "../../../../../../utils/interfaces/my_documents/fiscal_registry/IFiscalRegistry";


const useApiUpdateFiscalRegistry = (): UseMutationResult<IFiscalRegistry, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()


    const {put} = useApiCalls()

    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IFiscalRegistry> {
        try {
            const response = await put(`/api/company/${company_token}/my_documents/fiscal_registry/${pk}`, data);
            return response.data as IFiscalRegistry;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IFiscalRegistry, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ["useApiGetFiscalRegistry", data.id]});
            await queryClient.invalidateQueries({queryKey: ["useApiGetFiscalRegistries"]});
        },
    });
};


export default useApiUpdateFiscalRegistry;